/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Sales_Status_OkInputs */

const vi_warehouse_sales_status_ok = /** @type {(inputs: Warehouse_Sales_Status_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bình thường`)
};

/**

* @param {Warehouse_Sales_Status_OkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_sales_status_ok = /** @type {((inputs?: Warehouse_Sales_Status_OkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Sales_Status_OkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_sales_status_ok(inputs)
});